import { UserMaintenanceRoutes } from 'src/app/core/enums/routes.enum';

export function getLinkToMaintenanceComponent(componentId: string): string {
  return componentId
    ? `${UserMaintenanceRoutes.Component}/${componentId}`
    : UserMaintenanceRoutes.Main;
}

export function getLinkToMaintenanceJobDetails(componentId: string, jobId: string): string {
  return UserMaintenanceRoutes.JobOverview.replace(':id', jobId).replace(
    ':componentId',
    componentId
  );
}

export function getLinkToCorrectiveActionEdit(
  componentId: string,
  correctiveActionId: string
): string {
  return UserMaintenanceRoutes.CorrectiveActionEdit.replace(':componentId', componentId).replace(
    ':caId',
    correctiveActionId
  );
}

export function getLinkToCorrectiveActionPerform(
  componentId: string,
  correctiveActionId: string
): string {
  return UserMaintenanceRoutes.CorrectiveActionPerform.replace(':componentId', componentId).replace(
    ':caId',
    correctiveActionId
  );
}

export function getLinkToCorrectiveActionPerformDetails(
  componentId: string,
  correctiveActionId: string,
  performId: string
): string {
  return UserMaintenanceRoutes.CorrectiveActionPerformDetails.replace(':componentId', componentId)
    .replace(':caId', correctiveActionId)
    .replace(':performId', performId);
}

export function getLinkToMaintenanceJobPerformDetails(
  componentId: string,
  jobId: string,
  performId: string
): string {
  return UserMaintenanceRoutes.JobPerformDetails.replace(':componentId', componentId)
    .replace(':id', jobId)
    .replace(':performId', performId);
}
